import fetchWrapper from '../fetchWrapper';

const BASE_URL = process.env.BASE_URL;

interface TrackVisitorPayload {
    // U3-2: 현재 화면 식별자(라우트 경로)
    page?: string;
    // U3-1: 유입 경로(리퍼러/캠페인 파라미터). 최초 진입 때만 보낸다.
    referrer?: string;
}

/**
 * Track visitor page view
 */
async function trackVisitor(payload: TrackVisitorPayload = {}): Promise<any> {
    try {
        const response = await fetchWrapper.post(`${BASE_URL}/visitor-tracking/track`, payload);
        return response;
    } catch (error) {
        // Silently fail - don't disrupt user experience
        console.debug('Visitor tracking failed:', error);
        throw error;
    }
}

export const visitorTrackingService = {
    trackVisitor,
};
